Vue.component('leaderboardlegacy', {
  template: templates.leaderBoardLegacy,
  data() {
    return {
      model: {
        users: [],
        top: [],
        medals: [],
        isLoggedIn: false,
        currentPage: 0,
        limit: 50,
        totalPages: 0,
        totalPlayers: 0
      },
      cancelTokenSource: null
    };
  },
  mounted() {
    const c = this;
    c.get();
    c.getMedals();

    $('[data-view="viewer-dashboard"]').on(
      'click',
      '[data-component="leaderBoardLegacy"] .medal',
      function (e) {
        c.show($(this).clone());
      }
    );

    $('[data-view="viewer-dashboard"]').on(
      'click',
      '.view-element',
      function () {
        c.hide();
      }
    );
  },
  beforeDestroy() {
    const c = this;

    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    get() {
      const c = this;

      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Previous request canceled.');
      }

      c.cancelTokenSource = axios.CancelToken.source();

      const offset = c.model.currentPage * c.model.limit;

      legacyBattleService
        .getLeaderboard(c.model.limit, offset)
        .then(function (response) {
          console.log('Legacy Leaderboard Response:', response.data);

          let data = response.data;

          if (data.status === false) {
            c.model.users = [];
            c.model.top = [];
            return;
          }

          // Process leaderboard data
          let leaderboard = data.leaderboard || [];

          // Add rank and format data
          leaderboard.forEach((player, index) => {
            player.rank = offset + index + 1;
            player.achievements = player.achievements || [];

            // Format achievements with image paths
            player.achievements = player.achievements.map(medalId => ({
              id: medalId,
              image: `${root}/images/medals/${medalId}.png`
            }));
          });

          c.model.users = leaderboard;
          c.model.totalPlayers = data.total || 0;
          c.model.totalPages = Math.ceil(c.model.totalPlayers / c.model.limit);

          // Set top 3 (reorder as: 2nd, 1st, 3rd for visual prominence)
          if (leaderboard.length > 0) {
            let first = leaderboard.slice(0, 1);
            let second = leaderboard.slice(1, 2);
            let third = leaderboard.slice(2, 3);
            c.model.top = [...(second.length ? second : []), ...first, ...(third.length ? third : [])];
          }

          c.model.isLoggedIn = true;
        })
        .catch(function (error) {
          console.log('Error fetching legacy leaderboard:', error);
          c.model.users = [];
        });
    },
    getMedals() {
      const c = this;

      medalService
        .get()
        .then(function (response) {
          for (let medal of response.data) {
            medal.image = `${root}/images/medals/${medal.id}.png`;
          }
          c.model.medals = response.data;
        })
        .catch(function (error) {
          console.log('Error fetching medals:', error);
        });
    },
    nextPage() {
      const c = this;
      if (c.model.currentPage < c.model.totalPages - 1) {
        c.model.currentPage++;
        c.get();
        window.scrollTo(0, 0);
      }
    },
    previousPage() {
      const c = this;
      if (c.model.currentPage > 0) {
        c.model.currentPage--;
        c.get();
        window.scrollTo(0, 0);
      }
    },
    goToPage(pageNumber) {
      const c = this;
      if (pageNumber >= 0 && pageNumber < c.model.totalPages) {
        c.model.currentPage = pageNumber;
        c.get();
        window.scrollTo(0, 0);
      }
    },
    show($element) {
      const c = this;
      let id = $element.data('id');
      let video = `/videos/medals/${id}.webm`;
      let name = '';

      for (let medal of c.model.medals) {
        if (medal.id === id) {
          name = medal.name;
          break;
        }
      }

      if ($('[data-view="viewer-dashboard"] [data-modal="medal-modal"]').length) {
        $('[data-view="viewer-dashboard"]').find('[data-modal="medal-modal"]').remove();
      }

      $('[data-view="viewer-dashboard"]').append(`
        <div class="view-element" data-modal="medal-modal">
          <div class="modal">
            <video autoplay muted loop>
              <source src="${video}" type="video/webm" />
              Your browser does not support the video tag.
            </video>
            <h3>${name}</h3>
          </div>
        </div>
      `);
    },
    hide() {
      $('[data-view="viewer-dashboard"]').find('[data-modal="medal-modal"]').remove();
    }
  }
});
